module.exports = __webpack_public_path__ + "img/farzana-christopher-34.8ec37bf8.jpg";